import {createActionTypes, createActionCreators} from 'utils/reduxUtils';

const typesArray = [
    'ADMIN_COMPANY_ROUTE_MOUNTING',
    'PUBLIC_COMPANY_ROUTE_MOUNTING',
];

export const ActionTypes = createActionTypes(typesArray);
export const Actions = createActionCreators(typesArray);
